import React, { Fragment } from "react";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useCubicoAnalytics } from "./cubico_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./cubico_partner_config";
import { lazyWithRetry } from "../../core/lazy_with_retry";

const Theme = lazyWithRetry(() => import("./cubico_theme"));

const faqs = [
  {
    question: "What does a daily pass give me access to?",
    answer:
      "The Daily Pass grants you entry on the date you reserved during the hours of operation (9AM - 6PM). " +
      "Your daily pass booking gives you permission to work in any of the common areas " +
      "with access to a seat, a flat work surface, and a power source within reach.",
  },

  {
    question: "What are the hours of operation?",
    answer: "Our workspace is staffed Monday through Friday 9am-6pm.",
  },

  {
    question: "How do I modify or cancel my booking?",
    answer:
      "You may cancel/modify your reservation 24 hours before your booking begins.",
  },

  {
    question: "Do you offer printing services?",
    answer:
      "We offer access to business quality printing, copying, and scanning services.",
  },

  {
    question: "What is your animal policy?",
    answer: "We are pet friendly.",
  },

  {
    question: "Do you serve food and drink?",
    answer: "We offer complimentary coffee, tea, and water.",
  },
];

export function OfferingCubicoDayPass() {
  useCubicoAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: `Get access to all of Cubico's communal spaces: 7th Floor Penthouse, Outdoor Rooftop, 2nd Floor Terrace and our newly renovated cellar.`,
          faqs,
          testimonials: testimonials,
          generalInfo: generalInfo,
        }}
      />
    </Fragment>
  );
}
